import React, { useEffect, useState } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component';
import {
	/* eslint-disable-next-line no-restricted-imports */
	getExperienceTracker,
} from '@confluence/experience-tracker/entry-points/getExperienceTracker';
import { getAnalyticsWebClient } from '@confluence/analytics-web-client';

import { initialization } from './initialization';
import { SomethingWentWrong } from './SomethingWentWrong';
import { useExperienceFailureForRoute } from './useExperienceFailureForRoute';

type ErrorAppProps = ExperienceFailureForRootProps;

export const ErrorApp = ({ entryPoint }: ErrorAppProps) => {
	const [isInitialized, setInitialized] = useState(false);

	useEffect(() => {
		void initialization().then(() => {
			setInitialized(true);
		});
	}, []);

	return (
		<ExperienceTrackerContext.Provider value={getExperienceTracker()}>
			<SomethingWentWrong />
			{isInitialized ? <ExperienceFailureForRoot entryPoint={entryPoint} /> : null}
		</ExperienceTrackerContext.Provider>
	);
};

type ExperienceFailureForRootProps = {
	entryPoint?: string;
};

const ExperienceFailureForRoot = ({ entryPoint }: ExperienceFailureForRootProps) => {
	useEffect(() => {
		void getAnalyticsWebClient().then((client) =>
			client.sendScreenEvent({
				name: 'standaloneErrorApp',
			}),
		);
	}, []);

	// eslint-disable-next-line no-restricted-syntax
	useExperienceFailureForRoute(window.location.href, entryPoint);

	return null;
};
